import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import mobileRouterConifg from './router.js'
import Axios from '@/utils/diyaxios'
import Storage from '@/utils/localstorage'
import store from '@/store'
import toastRegistry from '@/extend/toast'
// import VueClipboard from 'vue-clipboard2'
import '@/assets/css/common/base.less';
import _ from '@/utils/util'

let token = Storage.get('NCG-token-ys')
let eid = Storage.get('NCG-eid-ys')

require('@/filters/filters.js')

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(toastRegistry)
// Vue.use(VueClipboard)
Vue.prototype.$http = Axios
Vue.prototype.$storage = Storage

const router = new VueRouter(mobileRouterConifg)
// window.vConsole = new window.VConsole();


const enter = () => {
  new Vue({
    router,
    render: h => h(App),
    store
  }).$mount('#app')
}

if (_.getDetect().os.neteaseCloud) {
  store.commit('setNeteasecloud', true)
}

let auth_token = _.getQuerys('token')

// 通过token登陆
if (auth_token) {
  const params = {
    auth_method: "auth-token",
    auth_token:auth_token
  }
  store.dispatch('getToken', params).then(() => {
    enter()
    // store.dispatch('getUser').then(() => {
    // }, () => {
    //   Storage.remove('NCG-token')
    // })
    
  }, () => {
    console.log('登陆过期')
    enter()
    Vue.prototype.$toast({
      type: 'fail',
      text: '登陆过期，请登陆后重试'
    })
  })

// 尝试获取apk的一次性token
} else if (_.getDetect().os.neteaseCloud) {
  const EnterApp = () => {
    console.log('进入apk')
    window.NCGJsBridge.invokeAsync('getAuthToken', '', (res)=> {
      try {
        const data = JSON.parse(res);
        store.dispatch('getToken', {
          auth_method: "auth-token",
          auth_token: data.auth_token
        }).finally(() => {
          enter()
        });
      } catch (e) {
        enter()
      }
    });
  }
  
  if (window.NCGJsBridge) {
    EnterApp()
  } else {
    document.addEventListener('NCGJsBridgeReady', EnterApp, false)
  }

} else if (token && eid) {
  // 缓存的token和uid
  store.commit('setToken', token)
  store.commit('setOFFSET', eid && _.getOffset2(_.cookieGet(eid)))
  enter()

} else {
  enter()
}